export 	function addDataTextToElements() {
    // Get all heading and paragraph elements
    var elements = document.querySelectorAll('h1, h2, h3, h4, h5, h6, p');

    // Loop through each element
    elements.forEach(function(element) {
        // Get the text content of the element
        var text = element.textContent.trim();
        
        // Add data-text attribute with the text content
        element.setAttribute('data-text', text);
    });
}